import { useContext, useEffect, useState } from "react";

import { Button, Modal, Form, Row, Col, Input } from "antd";
import { PasswordInput } from "antd-password-input-strength";
import { message } from "antd";
import zxcvbn from "zxcvbn";
import { AuthContext } from "../../../contexts/AuthContext";
import patchDataTrace from "../../../services/patchDataTrace";

export default function UpdatePassword({ isVisible, setVisible }: any) {
  const { user } = useContext(AuthContext);
  const [isLoading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const onSubmit = async () => {
    setLoading(true);
    const values = await form.validateFields();
    const { password } = form.getFieldsValue();
    const score = password.length === 0 ? -1 : zxcvbn(password).score;
    if (score < 3) {
      message.error("Use stronger password");
    } else {
      const uri = `users/${user?._id}/password/update`;
      const response = await patchDataTrace(values, uri);
      if (response.success) {
        message.success("Updated successfully");
        setVisible(false);
      } else {
        message.error(response.message);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [form, user]);

  return (
    <Modal
      visible={isVisible}
      title={<div className="flex">Update Password</div>}
      onCancel={() => setVisible(false)}
      width={680}
      footer={[
        <Button key="back" onClick={() => setVisible(false)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="updPword"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="updPword"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="oldpassword"
              rules={[
                {
                  required: true,
                  message: "Please enter old password",
                },
              ]}
            >
              <Input
                type="password"
                placeholder="Old Password"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: `Please enter Password`,
                },
              ]}
            >
              <PasswordInput
                inputProps={{
                  size: "middle",
                  placeholder: "New Password",
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
